import axios from "@/libs/api.request";
// 获取列表
export const getFlow = params => {
  return axios.request({
    url: `/user/client/walletFlow`,
    method: "get",
    params
  });
};

export const rechargeAmount = data => {
  return axios.request({
    url: `/pay`,
    method: "post",
    data
  });
};

export const getAmount = params => {
  return axios.request({
    url: `/pay/getBalance`,
    method: "get",
    params
  });
};

export const clearAmount = data => {
  return axios.request({
    url: `/pay/deductBalance`,
    method: "post",
    data
  });
};
